module.exports = __webpack_public_path__ + "img/logo-24px.e2189730.svg";